var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative select-none" },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 px-6 sticky top-18 z-20 bg-slate-300 border-b border-slate-400 flex flex-grow items-center justify-between gap-4",
          style: { minWidth: "calc(100vw - 22rem)" }
        },
        [
          _c("div"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sticky top-18 right-6 flex items-center gap-2" },
            [
              _c(
                "router-link",
                { attrs: { to: "client-acquisition/edit" } },
                [
                  _c("BlInputButton", {
                    attrs: { type: "outlined", label: "Edit pipeline" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.previewLoading
        ? _c("div", { staticClass: "w-full h-92 grid place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : _c(
            "div",
            { staticClass: "px-6 pt-3 pb-1 flex gap-6" },
            _vm._l(_vm.stages, function(stage) {
              return _c("PipelineStage", {
                key: stage.id,
                attrs: { stage: stage, dragId: _vm.dragId },
                on: { "drag-start": _vm.dragStart }
              })
            }),
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "fixed bottom-0 right-0 z-40 p-6" }, [
        _c(
          "button",
          {
            staticClass:
              "h-25 w-25 flex flex-col items-center justify-center gap-1 bg-light-purple hover:bg-dark-purple-200 rounded-full border-2 border-pure-white shadow-lg outline-none",
            attrs: { title: "New Target Databank" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.newProspectOpened = true
              }
            }
          },
          [
            _c("BlIcon", { attrs: { icon: "plus", color: "secondary" } }),
            _vm._v(" "),
            _c("BlTextSubtitle3", {
              staticClass: "text-pure-white",
              attrs: { text: "New" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.newProspectOpened
        ? _c("NewProspectModal", {
            on: {
              "close-modal": function($event) {
                _vm.newProspectOpened = false
              },
              "after-commit": function($event) {
                return _vm.fetchStageProspectStages($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.moveProspectOpened && _vm.destinationStage
        ? _c("MoveProspectModal", {
            attrs: {
              prospectStage: _vm.prospectStage,
              destinationStage: _vm.destinationStage,
              location: "kanban"
            },
            on: {
              "close-modal": function($event) {
                _vm.moveProspectOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.prospectMoveToOpened
        ? _c("BlBackdrop", { attrs: { footer: false } }, [
            _c(
              "div",
              { staticClass: "px-8 pt-8 pb-4 flex flex-col gap-2" },
              [
                _c("BlTextTitle4", { attrs: { text: "Move prospect to" } }),
                _vm._v(" "),
                _c("div", { staticClass: "flex" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-7 px-1 flex items-center gap-1 rounded bg-tulip-100"
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "h-6 w-6",
                        attrs: { icon: "user-square", color: "tulip-7" }
                      }),
                      _vm._v(" "),
                      _c("BlTextSubtitle3", {
                        staticClass: "text-tulip-700",
                        attrs: { text: _vm.prospectStage.prospect.name }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "px-8 flex flex-col gap-4 overflow-y-auto",
                style: { width: "40rem", maxHeight: "calc(100vh - 16rem)" }
              },
              _vm._l(_vm.stages, function(stage) {
                return _c(
                  "div",
                  {
                    key: stage.id,
                    staticClass: "flex items-center gap-4 cursor-pointer",
                    class: {
                      "opacity-50 pointer-events-none":
                        stage.id === _vm.prospectStage.stage.id
                    },
                    on: {
                      click: function($event) {
                        _vm.destinationStageId = stage.id
                      }
                    }
                  },
                  [
                    _c("BlInputRadio", {
                      attrs: {
                        checked: stage.id === _vm.destinationStageId,
                        disabled: stage.id === _vm.prospectStage.stage.id,
                        name: "select_destination_stage"
                      }
                    }),
                    _vm._v(" "),
                    _c("BlChip", { attrs: { chip: stage.name } })
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "px-8 pt-4 pb-8 flex items-center justify-end gap-4"
              },
              [
                _c("BlInputButton", {
                  attrs: { type: "plain", label: "Cancel" },
                  on: {
                    clicked: function($event) {
                      _vm.prospectMoveToOpened = false
                    }
                  }
                }),
                _vm._v(" "),
                _c("BlInputButton", {
                  attrs: {
                    label: "Confirm",
                    disabled: !_vm.destinationStageId,
                    loading: _vm.moveProspectLoading
                  },
                  on: { clicked: _vm.onMoveProspect }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.dragTarget
        ? _c(
            "div",
            {
              ref: "blProspectStageDecoy",
              staticClass: "pointer-events-none fixed",
              style: {
                left: _vm.dragPos.x + "px",
                top: _vm.dragPos.y + "px",
                width: _vm.dragPos.w + "px",
                zIndex: 100
              }
            },
            [
              _c("PipelineProspectStage", {
                key: _vm.dragTarget.id,
                attrs: { item: _vm.dragTarget }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dragMove
        ? _c(
            "div",
            {
              staticClass:
                "fixed bottom-0 right-0 z-50 p-3 grid grid-cols-3 items-center gap-3 bg-pure-white border border-slate-400",
              style: { minWidth: "calc(100vw - 22rem)" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "h-24 flex items-center justify-center flex-shrink-0 border-2 border-cornflower-800 bg-cornflower-200 border-dashed hover:bg-cornflower-800 hover:border-solid",
                  on: { mouseup: _vm.openMoveProspect }
                },
                [
                  _c("BlTextSubtitle2", {
                    staticClass:
                      "h-24 w-full text-center flex items-center justify-center text-cornflower-800 hover:text-pure-white",
                    attrs: { text: "Move to" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "h-24 flex items-center justify-center flex-shrink-0 border-2 border-rose-700 bg-rose-200 border-dashed hover:bg-rose-700 hover:border-solid",
                  on: { mouseup: _vm.openMoveProspectToDiscontinued }
                },
                [
                  _c("BlTextSubtitle2", {
                    staticClass:
                      "h-24 w-full text-center flex items-center justify-center text-rose-700 hover:text-pure-white",
                    attrs: { text: "Discontinued" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "h-24 flex items-center justify-center flex-shrink-0 border-2 border-lime-700 bg-lime-200 border-dashed hover:bg-lime-700 hover:border-solid",
                  on: { mouseup: _vm.openMoveProspectToAdmitted }
                },
                [
                  _c("BlTextSubtitle2", {
                    staticClass:
                      "h-12 w-full text-center flex items-center justify-center text-lime-700 hover:text-pure-white",
                    attrs: { text: "Admitted" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2142e47a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2142e47a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/pipeline/Kanban.vue
// module id = null
// module chunks = 